// extracted by mini-css-extract-plugin
export default {"home":"home_home__qA4gR","promos":"home_promos__rLf8t"};